import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${import.meta.env.VITE_BACKEND_URL}/api`;

/**
 * useCommunityGroups — grupos de WhatsApp da comunidade, em ordem.
 *
 * Os links NÃO ficam no bundle: o backend só devolve para plano pago ativo
 * (ou super admin) em GET /api/community/whatsapp-groups; para os demais a
 * resposta vem vazia. `enabled` evita até a chamada para quem não paga.
 * Cada grupo: { key, number, url } (url null = grupo ainda não configurado).
 * saveGroup é restrito a super admin no backend (PUT /api/platform-settings).
 */
export default function useCommunityGroups(enabled) {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setGroups([]);
      return undefined;
    }
    let cancelled = false;
    const token = localStorage.getItem('token');
    axios.get(`${API}/community/whatsapp-groups`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => { if (!cancelled) setGroups(res.data?.groups || []); })
      .catch(() => { if (!cancelled) setGroups([]); });
    return () => { cancelled = true; };
  }, [enabled]);

  const saveGroup = useCallback(async (key, url) => {
    const token = localStorage.getItem('token');
    await axios.put(`${API}/platform-settings`, { key, value: url }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setGroups((prev) => prev.map((g) => (g.key === key ? { ...g, url } : g)));
  }, []);

  return { groups, saveGroup };
}
